import React, { useEffect, useRef } from 'react';
import productHowItWorks1 from '../../photos/productHowItWorks1.svg';
import productHowItWorks2 from '../../photos/productHowItWorks2.svg';
import productHowItWorks3 from '../../photos/productHowItWorks3.svg';
import productValues1 from '../../photos/productValues1.svg';

const steps = [
  { num: '01', icon: productHowItWorks1, title: 'Прораховуємо перевезення', accent: 'в один клік' },
  { num: '02', icon: productHowItWorks2, title: 'Подаємо транспорт', accent: '' },
  { num: '03', icon: productHowItWorks3, title: 'Супроводжуємо клієнта', accent: 'на всіх етапах' },
  { num: '04', icon: productValues1, title: 'Розвантажуємо авто', accent: 'і чекаємо наступне замовлення' },
];

function ProductHowItWorks() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const cards = entry.target.querySelectorAll('.step-card');
            cards.forEach((card, i) => {
              setTimeout(() => {
                card.style.opacity = '1';
                card.style.transform = 'translateY(0)';
              }, i * 200);
            });
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} style={{
      padding: '120px 24px',
      background: 'linear-gradient(180deg, #0d1a0e 0%, #0a0a0f 100%)',
      position: 'relative',
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <h2 style={{
          textAlign: 'center',
          fontSize: 'clamp(24px, 4vw, 40px)',
          fontWeight: 700,
          color: '#fff',
          marginBottom: 60,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
        }}>
          Як ми <span style={{
            background: 'linear-gradient(135deg, #16b724, #4dc247)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>працюємо</span>
        </h2>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 32,
          position: 'relative',
        }}>
          {steps.map((step, i) => (
            <div key={i} className="step-card" style={{
              opacity: 0,
              transform: 'translateY(40px)',
              transition: 'all 0.7s cubic-bezier(0.4, 0, 0.2, 1)',
              padding: 40,
              borderRadius: 20,
              background: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(255,255,255,0.06)',
              textAlign: 'center',
              position: 'relative',
            }}
            onMouseOver={e => {
              e.currentTarget.style.background = 'rgba(22,183,36,0.06)';
              e.currentTarget.style.borderColor = 'rgba(22,183,36,0.2)';
              e.currentTarget.style.transform = 'translateY(-6px)';
            }}
            onMouseOut={e => {
              e.currentTarget.style.background = 'rgba(255,255,255,0.03)';
              e.currentTarget.style.borderColor = 'rgba(255,255,255,0.06)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
            >
              <div style={{
                fontSize: 48,
                fontWeight: 800,
                background: 'linear-gradient(135deg, rgba(22,183,36,0.3), rgba(22,183,36,0.1))',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                marginBottom: 20,
              }}>
                {step.num}
              </div>
              <div style={{
                width: 60,
                height: 60,
                borderRadius: '50%',
                background: 'rgba(22,183,36,0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 24px',
              }}>
                <img src={step.icon} alt="" style={{ height: 28, filter: 'brightness(0) invert(1)' }} />
              </div>
              <div style={{
                fontSize: 18,
                fontWeight: 600,
                color: '#fff',
                marginBottom: 8,
              }}>
                {step.title}
              </div>
              {step.accent && (
                <div style={{
                  fontSize: 15,
                  color: '#4dc247',
                  fontWeight: 500,
                }}>
                  {step.accent}
                </div>
              )}
            </div>
          ))}
        </div>

        <div style={{ textAlign: 'center', marginTop: 60 }}>
          <a href="tel:+380966341617" style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 10,
            padding: '16px 40px',
            background: 'linear-gradient(135deg, #16b724, #0e8a1a)',
            color: '#fff',
            fontSize: 16,
            fontWeight: 600,
            textDecoration: 'none',
            borderRadius: 50,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 30px rgba(22, 183, 36, 0.4)',
          }}
          onMouseOver={e => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 8px 40px rgba(22, 183, 36, 0.5)';
          }}
          onMouseOut={e => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 30px rgba(22, 183, 36, 0.4)';
          }}
          >
            Зателефонувати
          </a>
        </div>
      </div>

      <style>{`
        @media (max-width: 1024px) {
          section > div > div:first-of-type {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (max-width: 560px) {
          section > div > div:first-of-type {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
}

export default ProductHowItWorks;
